import { useEffect } from "react";
import { useFlagsmith } from "flagsmith/react";
import { useAuth } from "contexts/auth-provider";
import { useRegion } from "hooks/use-region";
import { identifyFlagsmithUser } from "lib/flagsmith";
import { identifyFullViewUser } from "lib/fullview";
import { identifyMixpanelUser } from "lib/mixpanel";

export function IdentifyObservability() {
  const { user } = useAuth();
  const region = useRegion();
  const flagsmith = useFlagsmith();

  useEffect(() => {
    if (user && region) {
      const userId = user.remote_id;
      const properties = {
        region,
        name: `${user.given_name} ${user.family_name}`,
        email: user.email,
        roles: user.roles,
      };
      identifyMixpanelUser(userId, properties);
      identifyFullViewUser(userId, properties);
      identifyFlagsmithUser(flagsmith, userId, {
        ...properties,
        roles: user.roles.join(", "),
      });
    }
  }, [flagsmith, region, user]);

  return null;
}
